import { useQuery } from '@tanstack/react-query';

export type FeatureFlagStatus = 'fully_released' | 'partially_released' | 'disabled';

export type FeatureFlagResponse = {
  key: string;
  name: string;
  status: FeatureFlagStatus;
  maintainer: string | null;
};

export const useAdminFeatureFlags = () => {
  const { data, isLoading, isError, error, refetch, isRefetching } = useQuery<
    FeatureFlagResponse[]
  >({
    queryKey: ['admin', 'feature-flags'],
  });

  return {
    flags: data,
    isLoading,
    isError,
    error,
    refetch,
    isRefetching,
  };
};
